import { Typography } from '@montugroup/design-system';
import { StyledLandingComponentContainer } from './LandingStyles';
import { paymentMethods } from './PaymentMethods';
import {
  PaymentLandingComponentContainer,
  StylePaymentIconContainer,
  StyledPaymentIconWrapper,
  StyledPaymentOptionsIcon,
  StyledPaymentSectionContentWrapper,
} from './PaymentSectionStyles';

export function PaymentSection() {
  return (
    <PaymentLandingComponentContainer>
      <StyledLandingComponentContainer>
        <StyledPaymentSectionContentWrapper>
          <Typography fontWeight={600} width={{ xs: '75%', md: '100%' }} variant="h5">
            Spread the cost, not your care
          </Typography>
          <Typography variant="body1">
            Flexible payment options mean you can pay for treatments in a way that suits your monthly budget, including
            Afterpay instalments.<sup>4</sup>
          </Typography>
        </StyledPaymentSectionContentWrapper>
        <StylePaymentIconContainer>
          <StyledPaymentIconWrapper>
            {paymentMethods.map((item, index) => (
              <StyledPaymentOptionsIcon key={`${item.name}-${index}-payment-section`}>
                <img src={item.src} alt={item.name} title={item.name} />
              </StyledPaymentOptionsIcon>
            ))}
          </StyledPaymentIconWrapper>
        </StylePaymentIconContainer>
      </StyledLandingComponentContainer>
    </PaymentLandingComponentContainer>
  );
}
